function initializeConfirmManager() {
    const modalElement = document.getElementById('app-confirm-modal');

    if (!modalElement || !window.bootstrap || !window.bootstrap.Modal) {
        console.warn('[confirm-manager] Confirm modal or Bootstrap modal API not found.');
        return;
    }

    const modalTitle = document.getElementById('app-confirm-modal-title');
    const modalMessage = document.getElementById('app-confirm-modal-message');
    const confirmButton = document.getElementById('app-confirm-modal-confirm');
    const cancelButton = document.getElementById('app-confirm-modal-cancel');

    const modalInstance = new bootstrap.Modal(modalElement);

    let currentResolve = null;
    let currentReject = null;
    let confirmAction = null;
    let hasConfirmed = false;

    function resetConfirmButton() {
        confirmButton.className = 'btn btn-primary';
        confirmButton.disabled = false;
        confirmButton.textContent = 'Confirm';
    }

    function resetModalContent() {
        modalTitle.textContent = 'Confirm Action';
        modalMessage.innerHTML = 'Are you sure you want to continue?';
        cancelButton.textContent = 'Cancel';
        resetConfirmButton();
    }

    function cleanupState() {
        currentResolve = null;
        currentReject = null;
        confirmAction = null;
        hasConfirmed = false;
        resetModalContent();
    }

    function normalizeOptions(options) {
        return Object.assign({
            title: 'Confirm Action',
            message: 'Are you sure you want to continue?',
            confirmText: 'Confirm',
            cancelText: 'Cancel',
            confirmVariant: 'primary',
            closeOnConfirm: true,
            onConfirm: null,
            onCancel: null,
        }, options || {});
    }

    function renderConfirmDialog(options) {
        const settings = normalizeOptions(options);

        resetModalContent();

        modalTitle.textContent = settings.title;
        modalMessage.innerHTML = settings.message;
        confirmButton.textContent = settings.confirmText;
        cancelButton.textContent = settings.cancelText;
        confirmButton.className = `btn btn-${settings.confirmVariant}`;

        confirmAction = settings.onConfirm;
        hasConfirmed = false;

        modalInstance.show();

        return new Promise(function (resolve, reject) {
            currentResolve = resolve;
            currentReject = reject;
        });
    }

    confirmButton.addEventListener('click', async function () {
        try {
            hasConfirmed = true;
            confirmButton.disabled = true;

            let result = true;

            if (typeof confirmAction === 'function') {
                result = await confirmAction();
            }

            if (currentResolve) {
                currentResolve(result !== false);
            }

            if (result !== false) {
                modalInstance.hide();
            } else {
                hasConfirmed = false;
                confirmButton.disabled = false;
            }
        } catch (error) {
            hasConfirmed = false;
            confirmButton.disabled = false;

            if (currentReject) {
                currentReject(error);
            } else {
                console.error('[confirm-manager] Confirm action failed.', error);
            }
        }
    });

    modalElement.addEventListener('hidden.bs.modal', function () {
        if (!hasConfirmed && currentResolve) {
            currentResolve(false);
        }

        cleanupState();
    });

    document.addEventListener('click', function (event) {
        const trigger = event.target.closest('[data-confirm]');
        if (!trigger) {
            return;
        }

        event.preventDefault();

        const title = trigger.dataset.confirmTitle || 'Confirm Action';
        const message = trigger.dataset.confirmMessage || 'Are you sure you want to continue?';
        const confirmText = trigger.dataset.confirmConfirmText || 'Confirm';
        const cancelText = trigger.dataset.confirmCancelText || 'Cancel';
        const confirmVariant = trigger.dataset.confirmVariant || 'primary';
        const formSelector = trigger.dataset.confirmForm || null;
        const href = trigger.dataset.confirmHref || trigger.getAttribute('href') || null;

        renderConfirmDialog({
            title,
            message,
            confirmText,
            cancelText,
            confirmVariant,
            onConfirm: function () {
                if (formSelector) {
                    const form = document.querySelector(formSelector);

                    if (!form) {
                        console.warn(`[confirm-manager] Form not found for selector: ${formSelector}`);
                        return false;
                    }

                    form.submit();
                    return true;
                }

                if (href && href !== '#') {
                    window.location.href = href;
                    return true;
                }

                return true;
            }
        }).catch(function (error) {
            console.error('[confirm-manager] Error while processing confirmation.', error);
        });
    });

    document.addEventListener('submit', function (event) {
        const form = event.target;

        if (!form.matches('[data-confirm-submit="true"]')) {
            return;
        }

        if (form.dataset.confirmed === 'true') {
            form.dataset.confirmed = 'false';
            return;
        }

        event.preventDefault();

        renderConfirmDialog({
            title: form.dataset.confirmTitle || 'Confirm Action',
            message: form.dataset.confirmMessage || 'Are you sure you want to continue?',
            confirmText: form.dataset.confirmConfirmText || 'Confirm',
            cancelText: form.dataset.confirmCancelText || 'Cancel',
            confirmVariant: form.dataset.confirmVariant || 'primary',
            onConfirm: function () {
                form.dataset.confirmed = 'true';
                form.submit();
                return true;
            }
        }).catch(function (error) {
            console.error('[confirm-manager] Error while handling form confirmation.', error);
        });
    });

    window.renderConfirmDialog = renderConfirmDialog;
}

document.addEventListener('DOMContentLoaded', initializeConfirmManager);
